import { useEffect, useRef } from 'react';
import { notificationDestination } from '../notificationNavigation';

const KEY = 'photo_pending_notification';
export default function useNotificationNavigation(account, loading, navigate) {
    const current = useRef({ account, loading });
    current.current = { account, loading };
    const handled = useRef(new Set());
    const pending = useRef(null);
    const apply = useRef(null);
    apply.current = message => {
        pending.current = message;
        try { sessionStorage.setItem(KEY, JSON.stringify(message)); } catch { /* storage may be unavailable */ }
        if (!current.current.account || current.current.loading) return;
        const id = message.clickId;
        if (!id || !handled.current.has(id)) {
            navigate(notificationDestination(message, current.current.account));
            if (id) handled.current.add(id);
        }
        pending.current = null;
        try { sessionStorage.removeItem(KEY); } catch { /* no storage */ }
        if (id) navigator.serviceWorker?.controller?.postMessage({ type: 'notification_navigated', clickId: id });
    };
    useEffect(() => {
        const url = new URL(window.location.href);
        const kind = url.searchParams.get('push_type');
        const clickId = url.searchParams.get('push_click');
        if (kind || clickId) {
            url.searchParams.delete('push_type'); url.searchParams.delete('push_click');
            apply.current({ type: 'navigate', url: url.pathname + url.search + url.hash, notifType: kind, clickId });
        } else {
            try { const raw = sessionStorage.getItem(KEY); if (raw) apply.current(JSON.parse(raw)); } catch { /* stale value */ }
        }
        const sw = navigator.serviceWorker;
        if (!sw) return;
        const onMessage = event => {
            if (event.data?.type !== 'navigate') return;
            apply.current(event.data);
            // Acknowledges that React received the message; SW retains it until auth is ready.
            event.ports?.[0]?.postMessage({ received: true });
        };
        const request = () => {
            if (!document.hidden) sw.controller?.postMessage({ type: 'get_notification_click' });
        };
        sw.addEventListener('message', onMessage);
        sw.addEventListener('controllerchange', request);
        window.addEventListener('focus', request); window.addEventListener('pageshow', request);
        document.addEventListener('visibilitychange', request);
        request();
        return () => {
            sw.removeEventListener('message', onMessage); sw.removeEventListener('controllerchange', request);
            window.removeEventListener('focus', request); window.removeEventListener('pageshow', request);
            document.removeEventListener('visibilitychange', request);
        };
    }, [navigate]);
    useEffect(() => { if (pending.current) apply.current(pending.current); }, [account, loading]);
}
